import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Y42AgGridModule } from '@y42/ag-grid';
import { LogoLoaderModule } from '@y42/core/logo-loader';
import { SmartBtnModule } from '@y42/core/smart-btn';
import { MonacoEditorModule } from '@y42/monaco-editor';
import { AngularSplitModule } from 'angular-split';
import { GitDiffTreeModule } from '../git-diff-tree';
import { VsCodeEditorModule } from '../vscode-editor';
import { GitConflictsDialogComponent } from './git-conflicts-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AngularSplitModule,
    MatDialogModule,
    MatButtonToggleModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatTooltipModule,
    LogoLoaderModule,
    MonacoEditorModule,
    FontAwesomeModule,
    Y42AgGridModule,
    GitDiffTreeModule,
    SmartBtnModule,
    VsCodeEditorModule,
  ],
  declarations: [GitConflictsDialogComponent],
  exports: [GitConflictsDialogComponent],
})
export class GitConflictsDialogModule {}
